import Moment from 'moment';

import { CalendarViewEnum } from '@shared/enums/calendarView.enum';
import { PlannerItemModelTypeEnum } from '@shared/enums/plannerItemModelType.enum';

import { AssignPeoplePermissionsEnum } from '../enums/assignPeoplePermissions.enum';

export const reformatCalendarItem = (
  item: any,
  isHasPackagePermission: boolean,
  calendarView: CalendarViewEnum,
) => {
  const isResizable = !(
    (item.model_type === PlannerItemModelTypeEnum.appointment ||
      item.model_type === PlannerItemModelTypeEnum.meet) &&
    calendarView !== CalendarViewEnum.week
  );

  return {
    ...item,
    start: Moment.utc(item?.started_at, 'YYYY-MM-DD HH:mm:ss')
      .local()
      .format(),
    end: Moment.utc(item?.finished_at, 'YYYY-MM-DD HH:mm:ss')
      .local()
      .format(),
    allDay: item?.is_all_day,
    editable:
      (item?.current_user?.role === AssignPeoplePermissionsEnum.editor ||
        item?.current_user?.role === AssignPeoplePermissionsEnum.creator) &&
      !isHasPackagePermission &&
      !item?.user_notification,
    resize: isResizable,
  };
};
